<template class="">
    <div class="login-page">
    <div class="alert" role="alert" id="snackbar">
      <strong>Error:</strong> Unable to logIn. Please check your Email/Password.
    </div>
    <div class="form bg-secondary">
        <form class="login-form" @submit.prevent="login">
        <input type="text" placeholder="Email" v-model="email">

        <div class="password-field">
          <input id="password" type="password" placeholder="Password" v-model="password">
          <span class="eye-toggle" @click="showPswd"><i class="fa fa-eye"></i></span>
        </div>
        <button type="button" class="btn-sm btn-info" @click="logIn">login</button>
        <p class="message">Forgot password? <a href="#" data-toggle="modal" data-target="#myModal">Reset</a></p>
        <p class="g-matrix">Powerd by <a href="http://g-matrixsystems.com/" target="_blank">G-Matrix Systems</a></p>
    </form>
    </div>

  <!-- PASS RESET MODAL -->
  <div class="modal fade" id="myModal" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Request password reset.</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <form class="pass_reset">
             <input 
             type="email" 
             placeholder="Enter email you are registered with." 
             id="email_pass_reset"
             class="email_pass_reset" 
             v-model="email_pass_reset" required>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-success" data-dismiss="modal" @click="pass_reset()">Submit</button>
          <button type="button" class="btn btn-sm btn-danger" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
// import router from '../../store/router'
export default {
  name: 'Login',
    data() {
      return {
        email: '',
        password: '',
        email_pass_reset: ''
      }
    },
    
    methods: {
    logIn() {
      this.$store.dispatch('retrieveToken', {
        email: this.email,
        password: this.password,
      })
    },

     showPswd() {
      var x = document.getElementById("password")
      if(x.type === "password") {
        x.type = "text"
      } else {
        x.type = "password"
      }
     },

     pass_reset() {
        // Self-service password reset was never wired to a working endpoint, and
        // the legacy PHP backend has been retired. Direct users to an admin.
        alert('Please contact your administrator to reset your password.')
     }
    }
}
</script>

<style scoped>
.login-page {
  width: 100%;
  max-width: 400px;
  padding: 0 16px;
  margin: auto;
  display: flex;
  align-items: center;
  min-height: 100vh;
}

.form {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  padding: 40px 36px;
  text-align: center;
  background: var(--surface) !important;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.45);
  color: var(--text);
}
.form input {
  font-family: var(--font-sans);
  outline: 0;
  background: var(--bg-base);
  color: var(--text);
  width: 100%;
  border: 1px solid var(--border);
  margin: 0 0 15px;
  padding: 12px 14px;
  box-sizing: border-box;
  font-size: 14px;
  border-radius: var(--radius-sm);
}
.form input:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-soft);
}

.login-form button {
  width: 100%;
  padding: 12px;
  margin-top: 4px;
  border: none;
  border-radius: var(--radius-sm);
  background: var(--accent);
  color: var(--accent-contrast);
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.15s ease;
}
.login-form button:hover {
  background: var(--accent-hover);
}

.form .message {
  margin: 18px 0 0;
  color: var(--text-muted);
  font-size: 12px;
}
.form .message a {
  color: #4CAF50;
  text-decoration: none;
}

.form .g-matrix {
  margin-top: 32px;
  color: var(--text-faint);
  font-size: 12px;
  text-align: center;
}
.form .g-matrix a {
  color: var(--accent);
  text-decoration: none;
}

.form .register-form {
  display: none;
}
.container {
  position: relative;
  z-index: 1;
  max-width: 300px;
  margin: 0 auto;
}
.container:before, .container:after {
  content: "";
  display: block;
  clear: both;
}
.container .info {
  margin: 50px auto;
  text-align: center;
}
.container .info h1 {
  margin: 0 0 15px;
  padding: 0;
  font-size: 36px;
  font-weight: 300;
  color: #1a1a1a;
}
.container .info span {
  color: #4d4d4d;
  font-size: 12px;
}
.container .info span a {
  color: #000000;
  text-decoration: none;
}
.container .info span .fa {
  color: #EF3B3A;
}

/* password field with the show/hide eye toggle */
.form .password-field {
  position: relative;
  margin: 0 0 15px;
}
.form .password-field input {
  margin: 0;
  padding-right: 42px; /* room for the eye */
}
.eye-toggle {
  position: absolute;
  top: 50%;
  right: 14px;
  transform: translateY(-50%);
  color: var(--text-muted);
  cursor: pointer;
  z-index: 2;
  line-height: 1;
}
.eye-toggle:hover {
  color: var(--accent);
}

.close {
  float: right;
}

.email_pass_reset {
  font-family: "Roboto", sans-serif;
  outline: 0;
  background: #f2f2f2;
  width: 100%;
  border: 0;
  margin: 0 0 15px;
  padding: 10px;
  box-sizing: border-box;
  font-size: 14px;
  border-radius: 5px;
}

.alert {
    width: 30%;
}

#snackbar {
	visibility: hidden;
	min-width: 250px;
  margin-left: -230px;
  text-align: center;
  background-color: #ff9966 !important;
	border-radius: 2px;
	padding: 5px;
	position: fixed;
	z-index: 1;
	left: 50%;
  top: 10px;
	font-size: 17px;
  }
  
  #snackbar.show {
	visibility: visible;
	-webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
	animation: fadein 0.5s, fadeout 0.5s 2.5s;
  }
</style>>